import { FeedbackQuestion } from "./feedback-question.model";

export class FeedbackSurvey {
    feedbackSurveyCode: string;
    feedbackSurveyTitle: string;
    feedbackSurveyText: string;
    feedbackQuestionList: FeedbackQuestion[];
    feedbackFromUserId: number;
    feedbackFromUserType: string;
    feedbackIconsToUse: string;
    feedbackEnteredByUserId: number;
    feedbackCompleted: boolean;
    feedbackSurveyInstanceCode: string;
    feedbackSurveyOrder: number;
    feedbackSurveyType: string;
    feedbackStartDate: Date;
    feedbackBookingId: string;

    constructor() {}
}